//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/javascript/util'
import EsQuery from '@/javascript/esQuery'
import { formatDate } from "@/javascript/formatDate"
import videoBox from '@/components/public-components/videoStart/index.vue'
import goSearch from '@/components/lyx-components/search-box/index.vue'
import tabWrap from '@/components/lyx-components/tab-wrap/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"
import EasyPlayer from '@easydarwin/easyplayer'
import Hls from 'hls.js'

export default {
  components: {
    goSearch,
    videoBox,
    tabWrap,
    goBack,
    Footer,
    EasyPlayer
  },
  data() {
    return {
      hls: null,
      minHeight: 0,
      pageNo: 0,
      pageSize: 7,
      infiniteAll: false,
      infiniteStatus: false,
      showState: false,
      strategyList: [],
      tabIndex: this.$route.params.tab,
      tabItems: ['全景', '慢直播', '视频'],
      showPic: true,
      showVideo: false,
      videoUrl: '',
      mzbUrl: '',
      videoShow: false,
      onePlay: "",
      videoLivelShow: false,
      playerOptions: {
        playbackRates: [1.0, 2.0, 3.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "application/x-mpegURL",
          src: "" //url地址
        }],
        poster: "", //你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
    }
  },
  mounted() {
    this.minHeight = document.documentElement.clientHeight
    document.title = "视觉海晏"
    // this.tabIndex = 0
    this.getStrategyList()
    /**
     * 微信签名分享
     */
    if (util.isWeiXin()) {
      const shareData = typeof (shareData) === 'undefined' ? {
        title: '视觉海晏',
        desc: this.SHARE_TEXT,
        imgUrl: this.SHARE_IMG,
        link: window.location.href
      } : shareData
      this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href.split('#')[0]) + '&appId=' + this.WX_APPID).then((response) => {
        util.initWxConfig(response.data.data, shareData)
      })
    }
  },
  methods: {
     videoClick(list, index) {
                this.videoShow = true
                this.videoUrl = this.PIC_BASE_URL + list[index]._source.videos[0][0].fileUrl
            },
 

    // tabHandler(index) {
    //   this.tabIndex = index + ''
    //   // this.strategyList = []
    //   this.pageNo = 0,
    //     this.pageSize = 7,
    //     this.infiniteAll = false,
    //     this.infiniteStatus = false,
    //     this.$router.replace(`/videoList/${index}`)
    //     this.strategyList = []
    //   this.getStrategyList()
    // },
    /**s
 * @msg: 获取直播视频路径
 * @param {type}
 * @return {type}
 */
    palyLivel (item) {
      if(item._source.link){
            window.open(item._source.link,'_blank')
            return
          } 
      this.$http.post("/hkapi/getVideo?protocol=hls&cameraId=" + item._source.description).then(res => {
        if (res && res.data && res.data.data) {
        
          this.videoLivelShow = true
          this.playerOptions.sources[0].src = res.data.data.url
          this.mzbUrl = res.data.data.url
          this.playerOptions.autoplay = true


          this.$nextTick(() => {
            const video = this.$refs.video;
 
            if (Hls.isSupported()) {
              this.hls = new Hls();
              this.hls.loadSource(this.mzbUrl);
              this.hls.attachMedia(video);
              this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                video.play();
              });
            } else if (video.canPlayType('application/vnd.apple.mpegURL')) {
              video.src = this.mzbUrl;
              video.addEventListener('loadedmetadata', () => {
                video.play();
              });
            }
          })


        }
      })
    },
       /**
  * @msg: 视频弹窗相关开始
  * @param {type}
  * @return {type}
  */
    closeBtn () {
      this.videoLivelShow = false
      this.playerOptions.poster = ''
      this.playerOptions.sources[0].src = ''
      this.hls.destroy()
    },
    getStrategyList() {
      const newsEsQuery = new EsQuery();
      const querystring6 = require("querystring");
      newsEsQuery
        .addStartWith(
          "deptCode",
          this.DEPT_CODE.DEPTCODE,
          newsEsQuery.and,
          false
        )
        .addString("publishStatus", 1, newsEsQuery.asc, false);
        

      newsEsQuery.addPage(this.pageNo * this.pageSize, this.pageSize);

      // if (this.tabItems[this.tabIndex] == '全景') {
      //   console.log('全景全景全景');
      //   newsEsQuery
      //     .addStartWith(
      //       "catalogCode",
      //       "00000000,1720424059487",
      //       newsEsQuery.and,
      //       false
      //     ).addSort("weight", newsEsQuery.desc, false);
      // } else if (this.tabItems[this.tabIndex] == '慢直播') {
        newsEsQuery
          .addStartWith(
            "catalogCode",
            "00000000,1720581537159",
            newsEsQuery.and,
            false
          ).addSort("createdDate", newsEsQuery.desc, false);
      // } else {
      //   newsEsQuery
      //     .addStartWith(
      //       "catalogCode",
      //       "00000000,1720488067268",
      //       newsEsQuery.and,
      //       false
      //     ).addSort("createdDate", newsEsQuery.desc, false);
      // }
      const newsJsList2 = JSON.stringify(newsEsQuery.getArray());

      this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring6.stringify({
            indexName: this.INDEX_NAME_TYPE.newsList,
            esJsonQuery: newsJsList2,
          })
        )
        .then(res => {
          window.addEventListener('scroll', this.windowScroll) // 监听滚动
          this.strategyList = [...this.strategyList, ...res.data.data]
          if (res.data.data.length < this.pageSize) {
            this.infiniteAll = true
          }
          this.infiniteStatus = false
        })
    },
    windowScroll() {
      // 底部加载
      if (util.pullUpLoad()) {
        this.infinite()
      }
    },
    infinite() {
      if (this.infiniteAll) {
        return
      }
      if (this.infiniteStatus) {
        return
      }
      this.pageNo += 1
      this.getStrategyList()
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.windowScroll)
  }
}
